import React from "react";

export default function AccordionBody(props) {
    const { expanded, children } = props

    return (
        <div className="accordion-body" style={{ display: expanded ? "" : "none" }}>{children}</div>
    )
}